export default __webpack_public_path__ + "static/media/arm-left-front.7a7eeb5e.png";